export const DAO_CODE = 'DASHBOARD_OFFICE_MANAGER' + '_DAO';
